import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/header';
import Body from './components/body';
import Footer from './components/footer';
import Bottom from './components/bottom';
import 'font-awesome/css/font-awesome.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';


function App() {
  return (
    <Router>
      <Header />
      <Body />
      <Footer />
      <Bottom />
    </Router>
  );
}

export default App;
